import profile from '../assets/profile.jpeg'
import circle from '../assets/circle.svg';
import redux from '../assets/redux.png';
import sass from '../assets/sass.png';
import Reactnative from '../assets/Reactnative.png';
import Logo from '../assets/logo.gif'



export default {
    profile,
    circle,
    redux,
    sass,
    Reactnative,
    Logo
};